module.exports = __webpack_public_path__ + "static/Mosel2-scaled-c3a3206b2addf7ca73e1c120cf14a5da.jpeg";